    import {Workbox} from 'workbox-window'
    import signalr_methods from "./signalR_methods";

    // import {bus} from './main.js'
    // import Vue from "vue";
    // export const bus = new Vue()
    let wb
    let notif_center

    if ('serviceWorker' in navigator) {
      wb = new Workbox(`${process.env.BASE_URL}service-worker.js?${process.env.VUE_APP_APP_VERSION}`)
      wb.addEventListener('controlling', () => {
        // window.location.reload()
      })
      wb.addEventListener('connect', (event) => {
        console.log("serice worker connect called")
        signalr_methods.initialize_signalR(registration)

      });
      wb.addEventListener('message', (event) => {

        if (event.data && event.data.type === 'MESSAGE_IDENTIFIER') {
          // do something
          console.log("serice worker MESSAGE_IDENTIFIER called")

        }
      });
      try{

        wb.register().then(registration => {
          console.log("registeration wb")
          notif_center = registration;
          signalr_methods.initialize_signalR(registration)
        })
      }catch (e) {
        console.log("registration faild")
        signalr_methods.initialize_signalR(notif_center)
      }

    } else {
      wb = null
    }

    // const filesToCache = [
    //   'views/messenger/ChatDetail.vue',
    //
    // ];
    //
    // const staticCacheName = 'pages-cache-v1';
    //
    // self.addEventListener('install', event => {
    //   console.log('Attempting to install service worker and cache static assets');
    //   event.waitUntil(
    //     caches.open(staticCacheName)
    //       .then(cache => {
    //         return cache.addAll(filesToCache);
    //       })
    //   );
    // });
    export default wb
